import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {BrowserRouter as Router, Route, Link} from "react-router-dom"

import { connect } from 'react-redux'
import {compose} from 'redux'


import { withStyles } from '@material-ui/core/styles'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
// import blue from '@material-ui/core/colors/blue'
// import purple from '@material-ui/core/colors/purple';
// import green from '@material-ui/core/colors/green';

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import {auth} from './helpers/firebase'
import Drawer from '@material-ui/core/Drawer'

import MenuItem from '@material-ui/core/MenuItem'
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar'


import WelcomeScreen from './components/WelcomeScreen'
import AuthScreen from './components/AuthScreen'
import ProfileScreen from './components/ProfileScreen'
import SpacesScreen from './components/spaces/SpacesScreen'
import SpaceScreen from './components/spaces/SpaceScreen'
import NewSpaceScreen from './components/spaces/NewSpaceScreen'

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: null
    }

    this.theme = createMuiTheme({
      palette: {
        type: 'light'
      }
    });
  
  
  }

  componentDidMount() {
    auth.onAuthStateChanged(currentUser => {

      if (currentUser) {
        this.setState({currentUser})
        console.log(`currentUser: ${currentUser}`)
      } else {
        console.log('reset currentUser')
        this.setState({currentUser: null})
      }
    })
  }

  logout = () => {
    auth.signOut()
    this.handleClose()
  }

  handleToggle = () => this.setState({open: !this.state.open})

  handleClose = () => this.setState({open: false})

  render() {
    const { title, classes } = this.props
    return (
      <MuiThemeProvider theme={this.theme}>
        <Router>
          <div>
            <AppBar>
              <Toolbar>
                <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.handleToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography variant="title" color="inherit" className={classes.flex}>
                  {title || 'JTY Admin'}
                </Typography>
                {
                  auth.currentUser 
                  ? <div className={classes.row}><Avatar alt={auth.currentUser.displayName} src={auth.currentUser.photoURL} className={classes.avatar} /><span>{auth.currentUser.displayName}</span></div>
                  : <Button color="inherit" component={Link} to="/signin">Login</Button>
                }
                
              </Toolbar>
            </AppBar>
            <div>
              <Drawer
                width={200}
                open={this.state.open}
                onClose={this.handleClose}
                className={classes.drawer}
              >

                <MenuItem onClick={this.handleClose} component={Link} to="/welcome" className={classes.list}>처음으로</MenuItem>
                <Divider />
                {
                  auth.currentUser
                  ? <MenuItem onClick={this.handleClose} component={Link} to="/spaces">Spaces</MenuItem>
                  : null
                }
                {
                  auth.currentUser
                  ? <MenuItem onClick={this.logout}>로그아웃</MenuItem>
                  : null
                }
              </Drawer>
              
            </div>
            {/* <Redirect from="/" to="welcome" /> */}
            <Route path="/welcome" component={WelcomeScreen} />
            <Route path="/signin" component={AuthScreen} />
            <Route path="/profile" component={ProfileScreen} />
            <Route path="/spaces" exact component={SpacesScreen} />
            <Route path="/spaces/:space_id" component={SpaceScreen} />
            <Route path="/new" component={NewSpaceScreen} />
          </div>
        </Router>        
      </MuiThemeProvider>
    );
  }
}

App.prototypes = {
  classes: PropTypes.object.isRequired
}


const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  avatar: {
    margin: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto'
  }
};

const mapStateToProps = (state) => {
  console.log(state)
  
  return {

  }
}

const mapDispatchToProps = {
  
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(App)


// WEBPACK FOOTER //
// ./src/App.js